var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6828 5.21799C17.08 4.54811 17.6447 3.99316 18.3214 3.60769C18.9981 3.22223 19.7635 3.01953 20.5423 3.01953C21.3211 3.01953 22.0865 3.22223 22.7632 3.60769C23.4399 3.99316 24.0046 4.54811 24.4018 5.21799L40.4558 32.292C40.8595 32.9727 41.0757 33.7482 41.0824 34.5396C41.0892 35.331 40.8863 36.11 40.4944 36.7976C40.1025 37.4851 39.5355 38.0567 38.8511 38.454C38.1667 38.8514 37.3892 39.0605 36.5978 39.06H4.48481C3.69339 39.0605 2.91596 38.8514 2.23154 38.454C1.54712 38.0567 0.980129 37.4851 0.5882 36.7976C0.196271 36.11 -0.00661635 35.331 0.000164564 34.5396C0.00694548 33.7482 0.223153 32.9727 0.626806 32.292L16.6828 5.21799Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5818 12.1562H19.0488V27.1032H21.5818V12.1562Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5818 31.082H19.0488V34.071H21.5818V31.082Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/IconWarning.b3126ce8.svg";
export { ForwardRef as ReactComponent };